import React from 'react';
import Layout from '@/components/Layout';
import SEO from '@/components/SEO';

const Accessibility = () => {
  // Schema.org עבור דף הצהרת נגישות
  const accessibilityPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "הצהרת נגישות |שלומית ז'בנר",
    "description": "הצהרת הנגישות של שלומית ז'בנר המפרטת את המחויבות שלנו לנגישות האתר בהתאם לתקן הישראלי 5568.",
    "publisher": {
      "@type": "Organization",
      "name": " שלומית ז'בנר",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.yourwebsite.com/logo.png"
      }
    },
    "inLanguage": "he-IL",
    "datePublished": "2025-03-01",
    "dateModified": "2025-03-01"
  };

  return (
    <>
      <SEO 
        title="הצהרת נגישות |שלומית ז'בנר"
        description="הצהרת הנגישות של  שלומית ז'בנר מפרטת כיצד אנו מבטיחים נגישות מלאה לכל המשתמשים בהתאם לתקן הישראלי 5568."
        keywords="הצהרת נגישות, נגישות, תקן ישראלי 5568, WCAG 2.0, נגישות אתרים, רמה AA"
        canonicalUrl="/accessibility"
        structuredData={accessibilityPageSchema}
      />
      <Layout>
        <div className="sr-only" id="main-content">תוכן הצהרת הנגישות מתחיל כאן</div>
        <main id="main-content" role="main" aria-labelledby="main-heading">
          <div className="container mx-auto px-6 py-12 md:py-20 max-w-4xl">
            <h1 id="main-heading" className="text-3xl md:text-4xl font-bold mb-8 text-tech-darkGray text-center">הצהרת נגישות</h1>
            
            <div className="bg-white rounded-xl p-8 shadow-sm space-y-6">
              <section className="space-y-4" aria-labelledby="introduction-heading">
                <h2 id="introduction-heading" className="text-2xl font-bold text-tech-darkGray">מבוא</h2>
                <p className="text-gray-600">
                  חברת שלומית ז'בנר  מאמינה ומקדמת את זכותם של אנשים עם מוגבלות להשתמש בטכנולוגיות דיגיטליות ובשירותים מקוונים. 
                  אנו מחויבים להנגיש את האתר שלנו בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות (תשנ"ח-1998) ולתקן הישראלי 5568 המבוסס על הנחיות WCAG 2.0 ברמה AA.
                </p>
              </section>

              <section className="space-y-4" aria-labelledby="site-adjustments-heading">
                <h2 id="site-adjustments-heading" className="text-2xl font-bold text-tech-darkGray">התאמות שבוצעו באתר</h2>
                <p className="text-gray-600">
                  האתר כולל את ההתאמות הבאות:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 pr-4">
                  <li>תפריט נגישות הכולל אפשרויות להגדלת טקסט, שינוי ניגודיות, הדגשת קישורים ועוד</li>
                  <li>תמיכה בניווט מקלדת מלא (באמצעות מקש Tab)</li>
                  <li>קישור "דלג לתוכן העמוד" בתחילת כל עמוד</li>
                  <li>תיאורי תמונות חלופיים (alt text) לכל התמונות באתר</li>
                  <li>מבנה דף ברור וסמנטי עם כותרות מדורגות</li>
                  <li>ניגודיות צבעים מספקת בהתאם לדרישות WCAG 2.0 AA</li>
                  <li>שמירה על פשטות השפה וקריאות הטקסט</li>
                  <li>תמיכה באמצעי עזר טכנולוגיים כגון קוראי מסך</li>
                </ul>
              </section>

              <section className="space-y-4" aria-labelledby="accessibility-contact-heading">
                <h2 id="accessibility-contact-heading" className="text-2xl font-bold text-tech-darkGray">פניות בנושא נגישות</h2>
                <p className="text-gray-600">
                  אנו עושים את מירב המאמצים להנגיש את האתר בצורה מיטבית, אך ייתכן כי באתר קיימים עדיין חלקים שטרם הונגשו, או שלא נמצא פתרון טכנולוגי מלא להנגשתם.
                </p>
                <p className="text-gray-600">
                  במידה ונתקלתם בבעיית נגישות או שיש לכם הצעה לשיפור הנגישות באתר, אנא פנו אלינו ונשמח לסייע:
                </p>
                <div className="bg-tech-gray p-6 rounded-lg">
                  <p className="text-gray-700 font-bold">פרטי רכז הנגישות:</p>
                  <p className="text-gray-600">שם: שלומית ז'בנר</p>
                  <p className="text-gray-600">תפקיד: ממונת נגישות</p>
                  <p className="text-gray-600">דוא"ל: <a href="mailto:support@zabnerit.com" className="text-tech-blue hover:underline">support@zabnerit.com</a></p>
                  <p className="text-gray-600">טלפון: <a href="tel:0501234567" className="text-tech-blue hover:underline">050-123-4567</a></p>
                </div>
              </section>

              <section className="space-y-4" aria-labelledby="disclaimer-heading">
                <h2 id="disclaimer-heading" className="text-2xl font-bold text-tech-darkGray">הצהרה</h2>
                <p className="text-gray-600">
                  אנו מצהירים בזאת כי אתר זה עומד בדרישות תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג-2013 ותקן ישראלי 5568 לנגישות תכנים באינטרנט ברמה AA.
                </p>
                <p className="text-gray-600">
                  האתר נבדק על ידי יועץ נגישות מוסמך ונמצא תואם לדרישות החוק והתקנות.
                </p>
              </section>

              <section className="space-y-4" aria-labelledby="tips-heading">
                <h2 id="tips-heading" className="text-2xl font-bold text-tech-darkGray">טיפים לשימוש נגיש באתר</h2>
                <div className="space-y-2">
                  <h3 className="text-lg font-bold text-tech-darkGray">ניווט באמצעות מקלדת</h3>
                  <p className="text-gray-600">
                    ניתן לנווט באתר באמצעות מקש Tab (ומקש Shift+Tab לניווט אחורה). לחיצה על Enter מפעילה את הקישור או הכפתור המסומן.
                  </p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-lg font-bold text-tech-darkGray">תפריט נגישות</h3>
                  <p className="text-gray-600">
                    בצד שמאל של האתר ניתן למצוא את כפתור הנגישות. לחיצה עליו תפתח את תפריט הנגישות המאפשר שינוי גודל טקסט, ניגודיות, צבעים ועוד.
                  </p>
                </div>

                <div className="space-y-2">
                  <h3 className="text-lg font-bold text-tech-darkGray">דילוג לתוכן העמוד</h3>
                  <p className="text-gray-600">
                    בתחילת כל עמוד קיים קישור "דלג לתוכן העמוד" המופיע עם הלחיצה הראשונה על מקש Tab, ומאפשר ניווט ישיר לתוכן העיקרי של העמוד.
                  </p>
                </div>
              </section>

              <p className="text-gray-500 text-sm mt-8 text-center">
                עדכון אחרון: מרץ 2025
              </p>
            </div>
          </div>
        </main>
      </Layout>
    </>
  );
};

export default Accessibility;